import React, { Component } from 'react';
import ReactGA from 'react-ga';
import { render } from 'react-dom';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import 'normalize.css';
import './styles/styles.css';

import Routes from './containers/Routes';

const trackingId = 'UA-155270573-1';
ReactGA.initialize(trackingId, { standardImplementation: true });

const history = createBrowserHistory();

history.listen(location => {
  ReactGA.set({ page: location.pathname });
  ReactGA.pageview(location.pathname);
});

class App extends Component {
  componentDidMount() {
    ReactGA.pageview(window.location.pathname);
  }

  render() {
    return (
      <Router history={history}>
        <Routes />
      </Router>
    );
  }
}

render(<App />, document.getElementById('artDirectorShow'));

if (module.hot) {
  module.hot.accept();
}
